export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-arrows-in-bfe663e43093ca985ab54934a906c14a.svg";